export default defineNuxtPlugin({
    name: 'tracking',
    setup(nuxtApp) {
        if (useRuntimeConfig().public.googleTagManager.disabled) return;

        nuxtApp.hook('page:finish', () => {
            const { trackPageView, trackLogState } = useTracking();
            trackPageView();
            trackLogState();
        });
    },
});
